import "../scss/private.scss";
import { eventQBus } from "./utils/EventQBus";
import { initToggles } from "./utils/Toggle";
import registerCompare from "./tiles/Compare";
import registerLazyTile from "./tiles/LazyTile";
import { registerTileNameMaxHeightFix } from "./tiles/TileNameMaxHeightFix";
import registerTooltipInitializer from "./tiles/TooltipInitializer";
import registerDiscountBenefit from "./tiles/DiscountBenefit";
import registerSimilarProductButton from "./tiles/SimilarProductsButton";

/*                              */
registerLazyTile();
registerTileNameMaxHeightFix();

eventQBus.on("assets.events.documentReady", () => {
  initToggles();
  registerCompare();
  registerTooltipInitializer();
  registerSimilarProductButton();
  registerDiscountBenefit();
});
